import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Button, Modal, Table, Badge, ListGroup } from "react-bootstrap";
import Papa from 'papaparse';

function ResumeTable({ children,project }) {
  const [tableData, setTableData] = useState([]);

  const convertCSVToJson = (csvText) => {
    return new Promise((resolve, reject) => {
      Papa.parse(csvText, {
        header: true, // Use the first row as headers
        skipEmptyLines: true, // Skip empty lines in the CSV file
        complete: function(results) {
          resolve(results.data); // Resolve with the parsed data
        },
        error: function(error) {
          reject(error); // Reject the promise on error
        }
      });
    });
  };
  
  
  useEffect(() => {
  function preprocessData(data) {
    const processedData = data.map(item => ({
      ...item,
      start: formatDate(item.start),
      end: formatDate(item.end)
    })).sort((a, b) => new Date(b.end) - new Date(a.end)); // Sort descending by start date
    return processedData;
  }
    // Fetch the CSV file from the public directory
    fetch('positions.csv')
    .then(response => response.text())  // Directly read the response as text
    .then(csvText => {
      console.log(csvText);
      convertCSVToJson(csvText).then(data => {  // Assuming convertCSVToJson accepts a CSV string
        console.log(data);

        data = preprocessData(data);

        setTableData(data);  // Update state with parsed data
      });
    })
    .catch(error => {
      console.error('Error fetching CSV file:', error);
    });  

  }, []);
  function formatDate(dateString) {
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    const lowerCasedDate = dateString.toLowerCase(); // Convert to lower case to handle case insensitivity
  
    if (lowerCasedDate.includes("present")) {
      // If 'present' is in the string, use the current date
      return new Date().toLocaleDateString('en-US', options);
    } else {
      // Otherwise, parse the provided date string
      return new Date(dateString).toLocaleDateString('en-US', options);
    }
  }
  
    return (
      <Container>
        <div className="sticky-top bg-white border-bottom py-2 d-none d-md-block">
          <Row className="align-items-start mb-1 mt-2">
            <Col>
              <h4 className="mb-1">AI Experience</h4>
            </Col>
            <Col xs="auto" className="text-md-end mt-2 mt-md-0">
              <Button
                as="a"
                href="https://calendly.com/justingirard/ai-art-chat"
                target="_blank"
                rel="noopener noreferrer"
                variant="primary"
                size="sm"
              >
                Book a conversation
              </Button>
            </Col>
          </Row>
          <p className="fs-6 mb-1">
            Justin has worked on early stage product teams since 2008, and commonly fills intermediate, senior, and co-founder level data roles.
          </p>
        </div>
        <div className="d-block d-md-none mb-3">
          <Row className="align-items-start mb-1 mt-2">
            <Col>
              <h4 className="mb-1">AI Experience</h4>
            </Col>
            <Col xs="auto" className="mt-2">
              <Button
                as="a"
                href="https://calendly.com/justingirard/ai-art-chat"
                target="_blank"
                rel="noopener noreferrer"
                variant="primary"
                size="sm"
              >
                Book a conversation
              </Button>
            </Col>
          </Row>
          <p className="fs-6 mb-1">
            Justin has worked on early stage product teams since 2008, and commonly fills intermediate, senior, and co-founder level data roles.
          </p>
        </div>
      <ListGroup variant="flush" className="mt-3">
        {tableData.map((item, index) => (
          <ListGroup.Item key={index} className="py-4">
            <div>
              <h5 className="mb-1">{item.title}</h5>
              <div className="d-flex flex-wrap align-items-center mb-2">
                <div className="me-2">{item.company}</div>
                <span className="text-muted mx-2" aria-hidden="true">·</span>
                <Badge bg="info" className="date-pill">
                  {formatDate(item.start)} - {formatDate(item.end)}
                </Badge>
              </div>
              <div className="mt-3">{item.description}</div>
            </div>
          </ListGroup.Item>
        ))}
      </ListGroup>
      {children}
    </Container>
  );
}

export default ResumeTable;
